module.exports = __webpack_public_path__ + "static/media/payoutWhite.aa1136c1.svg";